<script setup lang="ts">
import {useApp} from "~/store/useApp";
import {PropType} from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  index: {
    type: Number,
    required: true
  },
  validate: {
    type: Boolean as PropType<boolean>,
    required: false
  }
})

const emit = defineEmits(['change'])

const current = ref<number | null>(null)

function clickHandle(index: number) {
  current.value = index
  emit('change', index === 0, props.index)
}

const appStore = useApp()

const buttons = appStore.lang === 'he' ? ['כן', 'לא'] : ['Yes', 'No']

</script>

<template>
  <div>
    <label v-if="title" :class="['text-dark mb-2', validate ? 'text-red-500' : '']">
      {{ title }}
    </label>
    <div class="flex gap-3">
      <button
          type="button"
          v-for="(button, index) in buttons"
          class="w-[56px]"
          :class="[
            index == current ? 'active' : 'notActive',
            'w-[86px] h-[40px] lg:h-[43px] rounded-[5px] shadow-md',
        ]"
          @click="clickHandle(index)"
      >
        {{ button }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.active {
  @apply bg-ui text-white
}

.notActive {
  @apply bg-white text-ui
}
</style>